import axios, { AxiosError } from 'axios';

export type Doc = {
	id: string;
	/** Название файла */
	name: string;
	/** Идентификатор файла */
	type: string;
	/** Mime type */
	mime?: string;
	/** Файл */
	file: File | string;
	/** Содержимое файла в base64 */
	body?: string;
	/** Флаг обязательности */
	required: boolean;
	/** Ссылка на файл */
	url?: string;
};

export const getDocs = async (subject: 'ie' | 'llc') => {
	try {
		const { data } = await axios.get<{
			docs: {
				/** ID документа (используется при отправке данных) */
				id: string;
				/** Название документа */
				title: string;
				/** Тип документа */
				value: string;
				/** Флаг обязательности для заполнения */
				required?: boolean;
			}[];
		}>(`${process.env.HOST}/api_v1/docs/?subject_type=${subject}`);
		const docs: Doc[] = data?.docs?.map((doc) => ({
			id: doc.id ?? null,
			name: doc.title,
			type: doc.value,
			file: null,
			required: doc?.required ?? true,
		}));
		return docs;
	} catch (error) {
		if (error instanceof AxiosError) {
			console.log(error?.response?.data);
		} else {
			console.log(error);
		}
	}
};
